import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Headline3 } from 'venn-ui-kit';
import { blockFonts, getCustomFontSize } from 'venn-state';

import { type HTMLProps } from '../factory';
import { useRecoilValue } from 'recoil';

export type BlockHeadlineElement = React.ElementRef<'div'>;
export interface BlockHeadlineProps extends HTMLProps<'div'> {
  id: string;
  children: React.ReactNode;
}

export const BlockHeadline = forwardRef<BlockHeadlineElement, BlockHeadlineProps>((props, ref) => {
  const { id, children } = props;

  const titleFont = useRecoilValue(blockFonts.blockTitle(id));
  const fontSize = getCustomFontSize(titleFont);

  return (
    <Headline ref={ref} data-testid="qa-block-header" style={{ fontSize }}>
      {children}
    </Headline>
  );
});

BlockHeadline.displayName = 'BlockHeadline';

const Headline = styled(Headline3)`
  margin: 0;
  vertical-align: middle;
`;
